// extracted by mini-css-extract-plugin
module.exports = {"statLabel":"StatLabels_statLabel__EcB0d"};